import React, { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { CardElement } from "@stripe/react-stripe-js";
import { axiosInstance } from "../../api/axiosDefaults";
import styles from "../../styles/BillingPage.module.css";

const StripeField = ({ label, id, children }) => (
  <Form.Group controlId={id}>
    <Form.Label>{label}</Form.Label>
    <div className={styles.StripeField}>{children}</div>
  </Form.Group>
);

export default function PaymentMethodFormFields({
  cardElementOptions,
  billingDetails,
  onBillingDetailsChange,
  disabled = false,
}) {
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);

  const country = billingDetails?.country || "";

  useEffect(() => {
    if (!country) {
      setStates([]);
      return;
    }

    axiosInstance
      .get(`/states/${country}/`)
      .then((response) => setStates(response?.data?.data || []))
      .catch((error) => {
        console.error("Error fetching states:", error);
        setStates([]);
      });
  }, [country]);

  useEffect(() => {
    axiosInstance
      .get("/countries/")
      .then((response) => setCountries(response?.data?.data || []))
      .catch((error) => console.error("Error fetching countries:", error));
  }, []);

  return (
    <>
      <StripeField label="Card details" id="cardDetails">
        <div className={styles.StripeElementInner}>
          <CardElement options={cardElementOptions} />
        </div>
      </StripeField>

      <Form.Group controlId="billingAddressLine1">
        <Form.Label>Address</Form.Label>
        <Form.Control
          type="text"
          name="addressLine1"
          value={billingDetails?.addressLine1 || ""}
          onChange={onBillingDetailsChange}
          placeholder="Enter your address"
          required
          disabled={disabled}
        />
      </Form.Group>

      <Form.Group controlId="billingCountry">
        <Form.Label>Country</Form.Label>
        <Form.Control
          as="select"
          name="country"
          value={country}
          onChange={onBillingDetailsChange}
          required
          disabled={disabled}
        >
          <option value="">Select Country</option>
          {countries.map((item) => (
            <option key={item.code2} value={item.code2}>
              {item.name}
            </option>
          ))}
        </Form.Control>
      </Form.Group>

      <Form.Group controlId="billingState">
        <Form.Label>State</Form.Label>
        <Form.Control
          as="select"
          name="state"
          value={billingDetails?.state || ""}
          onChange={onBillingDetailsChange}
          required
          disabled={disabled || !country}
        >
          <option value="">Select State</option>
          {states.map((state) => (
            <option key={state.name} value={state.name}>
              {state.name}
            </option>
          ))}
        </Form.Control>
      </Form.Group>

      <Row>
        <Col xs={12} md={6}>
          <Form.Group controlId="billingCity">
            <Form.Label>City</Form.Label>
            <Form.Control
              type="text"
              name="city"
              value={billingDetails?.city || ""}
              onChange={onBillingDetailsChange}
              placeholder="Enter your city"
              required
              disabled={disabled}
            />
          </Form.Group>
        </Col>
        <Col xs={12} md={6}>
          <Form.Group controlId="billingPostalCode">
            <Form.Label>Postal Code</Form.Label>
            <Form.Control
              type="text"
              name="postalCode"
              value={billingDetails?.postalCode || ""}
              onChange={onBillingDetailsChange}
              placeholder="Enter postal code"
              required
              disabled={disabled}
            />
          </Form.Group>
        </Col>
      </Row>
    </>
  );
}
